import { makeStyles } from '@mui/styles';

const style = makeStyles((theme?: any) => ({
  segment: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    textAlign: 'center',
    position: 'relative',

    '&::after': {
      content: "''",
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: '0',
      left: '0',
      backgroundImage: `url(${process.env.NEXT_PUBLIC_CDN}/images/icons/dot.png)`,
    },
  },
  mainHeading: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  highlightText: {
    background: '#faed61',
    paddingRight: '5px',
    paddingLeft: '5px',
  },
  highlightChip: {
    background: '#faed61',
    padding: '6px 15px',
  },
  [theme.breakpoints.up('sm')]: {
    mainHeading: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(10),
    },
  },
}));

export default style;
